import { mergeStyles } from 'office-ui-fabric-react';
import { HostAppColors } from './HostAppColors';
import { ThemeColorPalette, ShadowStyles } from '@fluidx/office-fluid-types';

export const getPrimaryButtonStyle = (appColors: HostAppColors) => {
  return mergeStyles({
    fontFamily:
      "'Segoe UI Semibold', 'Segoe UI Web (West European)', 'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
    backgroundColor: appColors.themePrimary,
    borderColor: appColors.themePrimary,
    boxShadow: ShadowStyles.shadowLevel4,
    selectors: {
      ':hover': {
        background: appColors.themeDarkAlt,
        borderColor: appColors.themeDarkAlt
      },
      ':disabled': {
        background: ThemeColorPalette.Neutral.neutralLighter,
        color: '#BEBBB8',
        borderColor: ThemeColorPalette.Neutral.neutralLighter
      },
      ':active': {
        background: appColors.themeDark,
        borderColor: appColors.themeDark
      }
    }
  });
};
